import { render, staticRenderFns } from "./AutorizacionesTarjetaPasajeros.vue?vue&type=template&id=2c494311&scoped=true"
import script from "./AutorizacionesTarjetaPasajeros.vue?vue&type=script&lang=js"
export * from "./AutorizacionesTarjetaPasajeros.vue?vue&type=script&lang=js"
import style0 from "./AutorizacionesTarjetaPasajeros.vue?vue&type=style&index=0&id=2c494311&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c494311",
  null
  
)

export default component.exports